import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.empty');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-empty',
template: templateSource || '',
    styles: [``],
})
export class LayoutEmptyComponent implements OnInit {
    public authorized: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        if (!this.service.auth.isPublicPath() && !this.service.auth.requireLogin())
            return;

        this.authorized = true;
        await this.service.render();
    }
}

export default LayoutEmptyComponent;